import axios from 'axios';

const formDataFieldName = 'file'; // REQUIRED NAME IN JW

export const jwBaseConfig = {
	headers : {
		'Content-Type': 'multipart/form-data',
		'Accept': '*/*'
	},
	withCredentials: false
};

export function saveTrackToJW(link, file) {
	const formData = new FormData();

	formData.append(formDataFieldName, file, file.name);

	return axios.post(link, formData, jwBaseConfig)
		.then(res => res.data);
}

export function saveVideo(link, file, reqestConfig = {}) {
	const formData = new FormData();

	formData.append(formDataFieldName, file, file.name);

	return axios.post(link, formData, {
		...reqestConfig,
		...jwBaseConfig
	}).then(res => res.data);
}

export default {
	saveTrackToJW,
	saveVideo
};